import { render, staticRenderFns } from "./dataResource.vue?vue&type=template&id=943208ca&scoped=true&"
import script from "./dataResource.vue?vue&type=script&lang=js&"
export * from "./dataResource.vue?vue&type=script&lang=js&"
import style0 from "./dataResource.vue?vue&type=style&index=0&id=943208ca&lang=scss&scoped=true&"
import style1 from "./dataResource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943208ca",
  null
  
)

export default component.exports